export default __webpack_public_path__ + "static/media/calendar.cdccb691.svg";